module.exports = __webpack_public_path__ + "static/media/sonja-guina-39897-unsplash-sm.f2f3bcdd.jpg";